import React from "react"
import { PageContent, PageTitle } from "../../components/PageContent/PageContent"

export function TeacherBellringers(props) {
    let title = "Bellringers"

    return (
        <PageContent className="">
            <PageTitle title={title}></PageTitle>
            Teacher view will be here...
        </PageContent>
    )
}